// extracted by mini-css-extract-plugin
export default {"chooseRole":"chooseRole_chooseRole__FOjBM","selectBlock":"chooseRole_selectBlock__9lGXE","selectBlockItem":"chooseRole_selectBlockItem__3qR2P","logo":"chooseRole_logo__VBQV2"};